import BaseApiCall from "./BaseApiCall";
import axios from "axios";
import apiConfig from "../api/apiConfig";

export const loadClientSummary = async (params) => {
    try {
        const response = await BaseApiCall.post("/tickets/load-client-summary", params);
        return response;
    } catch (error) {
        console.error('Loading error:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
}

export const loadClientTickets = async (params) => {
    try {
        const response = await BaseApiCall.post("/tickets/load-client-ticket", params);
        return response;
    } catch (error) {
        console.error('Loading error:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
}